// extracted by mini-css-extract-plugin
module.exports = {"styledSelect":"styles_styledSelect__Leeml","label":"styles_label__aGeUW","menu":"styles_menu__OVZ_n"};